import React, { useState } from 'react';
import { Check } from 'lucide-react';

interface ColorPickerProps {
  colors: string[];
  selectedColor: string;
  onColorSelect: (color: string) => void;
  allowCustom?: boolean;
  type?: 'text' | 'background';
}

export const ColorPicker: React.FC<ColorPickerProps> = ({
  colors,
  selectedColor,
  onColorSelect,
  allowCustom = false,
  type = 'text'
}) => {
  const [showCustom, setShowCustom] = useState(false);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-6 gap-2">
        {colors.map((color) => (
          <button
            key={color}
            className={`w-8 h-8 rounded-full flex items-center justify-center ${
              selectedColor === color ? 'ring-2 ring-offset-2 ring-blue-500' : ''
            }`}
            style={{ backgroundColor: color }}
            onClick={() => onColorSelect(color)}
          >
            {selectedColor === color && (
              <Check className={`w-4 h-4 ${color === '#FFFFFF' ? 'text-black' : 'text-white'}`} />
            )}
          </button>
        ))}
        {allowCustom && (
          <button
            className="w-8 h-8 rounded-full bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500"
            onClick={() => setShowCustom(!showCustom)}
          />
        )}
      </div>

      {allowCustom && showCustom && (
        <div className="pt-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Couleur personnalisée
          </label>
          <input
            type="color"
            value={selectedColor}
            onChange={(e) => onColorSelect(e.target.value)}
            className="w-full h-10 p-1 rounded-md"
          />
        </div>
      )}
    </div>
  );
};